// extracted by mini-css-extract-plugin
module.exports = {"SearchButton":"SearchButton__SearchButton__kXTsZ","active":"SearchButton__active__3Pfx-"};